import { ConsentBanner, CustomLinkProps } from '@ifixit/consent-banner';
import { ShopifyConfig } from '@ifixit/consent-banner/shopify-consent';
import { cn } from '@ifixit/ui/lib/utils';
import { initializeChakraComponent } from 'Shared/chakra-initialize';
import { PropsWithChildren } from 'react';

function CarpenterConsentComponent({
   isTest,
   flagEnabled,
   privacyPolicyUrl = '/Info/Privacy',
   piwikSiteId,
   needsConsent,
   shopifyConfig,
}: {
   isTest: boolean;
   flagEnabled: boolean;
   privacyPolicyUrl?: string;
   piwikSiteId: string;
   needsConsent: boolean;
   shopifyConfig: ShopifyConfig;
}) {
   if (isTest && !flagEnabled) {
      return null;
   }

   const CustomLink = ({ children, href, className }: PropsWithChildren<CustomLinkProps>) => (
      <a href={href} className={cn('underline', className)}>
         {children}
      </a>
   );

   return (
      <ConsentBanner
         CustomLink={CustomLink}
         privacyPolicyUrl={privacyPolicyUrl}
         needsConsent={needsConsent}
         piwikSiteId={piwikSiteId}
         shopifyConfig={shopifyConfig}
      />
   );
}

initializeChakraComponent('ConsentBanner', CarpenterConsentComponent);
